import { MobileAppVersionData, MobileAppVersionListApiResponse, MobileAppVersionGetApiResponse } from "../context/MobileAppVersionContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-mobile-app-version",
	UPDATE: "/cms/update-mobile-app-version",
	REMOVE: "/cms/remove-mobile-app-version",
	GET: "/cms/get-mobile-app-version-details",
	LIST: "/cms/get-mobile-app-version-list",
};

export class MobileAppVersionService {
	static async addMobileAppVersion(mobileAppVersionData: MobileAppVersionData) {
		const formData = new FormData();

		formData.append("platform", mobileAppVersionData.platform ?? "");
		formData.append("version", mobileAppVersionData.version ?? "");
		formData.append("forceUpdate", mobileAppVersionData.forceUpdate ? "true" : "false");
		formData.append("appId", mobileAppVersionData.appId?.toString() ?? "1");

		const response = await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
		return response.data;
	}

	static async getMobileAppVersionList(): Promise<MobileAppVersionListApiResponse> {
		const response = await axiosInstance.get(ENDPOINTS.LIST);
		return response.data;
	}

	static async getMobileAppVersionDetails(id: string): Promise<MobileAppVersionGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?versionId=${id}`);
		return response.data;
	}

	static async removeMobileAppVersion(id: string) {
		const response = await axiosInstance.delete(`${ENDPOINTS.REMOVE}?versionId=${id}`);
		return response.data;
	}

	static async updateMobileAppVersion(mobileAppVersionData: MobileAppVersionData) {
		const formData = new FormData();

		if (mobileAppVersionData.versionId?.trim()) {
			formData.append("versionId", mobileAppVersionData.versionId);
		}

		if (mobileAppVersionData.version?.trim()) {
			formData.append("version", mobileAppVersionData.version ?? "");
		}

		if (mobileAppVersionData.platform?.trim()) {
			formData.append("platform", mobileAppVersionData.platform ?? "");
		}

		if (mobileAppVersionData.forceUpdate !== undefined) {
			formData.append("forceUpdate", mobileAppVersionData.forceUpdate ? "true" : "false");
		}

		if (mobileAppVersionData.appId !== undefined) {
			formData.append("appId", mobileAppVersionData.appId.toString());
		}

		const response = await axiosInstance.patch(`${ENDPOINTS.UPDATE}`, formData);
		return response.data;
	}
}